import { useEffect } from "react";

const SCROLLING_ATTRIBUTE = "data-scrolling";
const SCROLL_IDLE_MS = 600;

/** Sets the attribute on scroll and clears it once idle. Returns the teardown. */
const watchScrolling = (scroller: HTMLElement) => {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const onIdle = () => {
        timeout = undefined;
        scroller.removeAttribute(SCROLLING_ATTRIBUTE);
    };
    const onScroll = () => {
        if (timeout === undefined) {
            scroller.setAttribute(SCROLLING_ATTRIBUTE, "true");
        } else {
            clearTimeout(timeout);
        }
        timeout = setTimeout(onIdle, SCROLL_IDLE_MS);
    };
    scroller.addEventListener("scroll", onScroll, { passive: true });
    return () => {
        clearTimeout(timeout);
        scroller.removeEventListener("scroll", onScroll);
        scroller.removeAttribute(SCROLLING_ATTRIBUTE);
    };
};

/**
 * Marks `scroller` with `data-scrolling="true"` from its first scroll event
 * until it has been idle for 600ms, without re-rendering. The board's thin
 * scrollbar shows its thumb while the attribute is set.
 */
export const useScrollingAttribute = (scroller: HTMLElement | null) => {
    useEffect(
        () => (scroller === null ? undefined : watchScrolling(scroller)),
        [scroller],
    );
};
